export default ({ number, children }) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'VND'
  }).format(Number(number || children))
